var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-field-label-pane__field-container" },
    [
      _c(
        "div",
        {
          staticClass: "custom-field-label-pane__field-container-header",
          attrs: {
            "data-bind-main-type": _vm.fieldMainType,
            "data-bind-field-type": _vm.field.field_type,
            "data-bind-field-id": _vm.field.field_id,
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "custom-field-label-pane__field-container-header__label",
            },
            [
              _c(
                "ElTooltip",
                {
                  attrs: {
                    disabled: !_vm.controller.fieldLabelScopeIsSpace(_vm.field),
                    effect: "light",
                    "visible-arrow": false,
                    content: _vm.controller.spaceScopeFieldTip
                      ? _vm.controller.spaceScopeFieldTip
                      : _vm.$t("PtCustomFieldLabelPane.spaceScopeFieldTip"),
                    placement: "top",
                    "popper-class": "pt-ui-tooltip",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "scope-field-icon" },
                    [
                      _vm.controller.fieldLabelScopeIsSpace(_vm.field)
                        ? _c("div", {
                            staticClass: "scope-field-icon__triangle",
                          })
                        : _vm._e(),
                      _c("PtIcon", {
                        style: {
                          color: _vm.fieldColorList[_vm.field.field_color],
                        },
                        attrs: {
                          icon: _vm.fieldPtIconMappings[_vm.field.field_type],
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" " + _vm._s(_vm.field.field_name) + " "),
              _vm.field.show_ai
                ? _c(
                    "ElTooltip",
                    {
                      attrs: {
                        effect: "light",
                        "visible-arrow": false,
                        content: _vm.$t("PtCustomFieldLabelPane.iconCheck"),
                        placement: "top",
                        "popper-class": "pt-ui-tooltip",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "ai-check-icon",
                          attrs: { "data-patent-field-id": _vm.field.field_id },
                          on: {
                            click: function ($event) {
                              return _vm.controller.onClickAICheckIcon(
                                _vm.field
                              )
                            },
                            mouseenter: function ($event) {
                              return _vm.controller.onHoverAICheckIcon(
                                _vm.field.field_id,
                                true,
                                $event
                              )
                            },
                            mouseleave: function ($event) {
                              return _vm.controller.onHoverAICheckIcon(
                                _vm.field.field_id,
                                false,
                                $event
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "patsnap-biz-icon",
                              staticStyle: { "font-size": "20px" },
                            },
                            [
                              _c("use", {
                                staticClass: "normal",
                                attrs: { href: "#SolidAiTaggingStar" },
                              }),
                              _c("use", {
                                staticClass: "active",
                                attrs: { href: "#SolidTick" },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.controller.isPinSupported(_vm.field)
            ? [
                _vm.controller.isFieldPinned(_vm.field.field_id)
                  ? _c(
                      "ElTooltip",
                      {
                        key: "pin-active",
                        staticClass:
                          "custom-field-label-pane__field-container-header__pin-btn",
                        attrs: {
                          effect: "dark",
                          "visible-arrow": false,
                          content: _vm.$t("PtCustomFieldLabelPane.pin.unPin"),
                          placement: "top-end",
                          "popper-class": "pt-ui-tooltip",
                        },
                      },
                      [
                        _c("PtIcon", {
                          staticClass: "active",
                          attrs: { icon: "SolidPinFill" },
                          on: {
                            click: function () {
                              return _vm.controller.toggleFieldPin(
                                _vm.field.field_id
                              )
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "ElTooltip",
                      {
                        key: "pin-inactive",
                        staticClass:
                          "custom-field-label-pane__field-container-header__pin-btn",
                        attrs: {
                          effect: "dark",
                          "visible-arrow": false,
                          content: _vm.$t("PtCustomFieldLabelPane.pin.pin"),
                          placement: "top-end",
                          "popper-class": "pt-ui-tooltip",
                        },
                      },
                      [
                        _c("PtIcon", {
                          attrs: { icon: "SolidPinLine" },
                          on: {
                            click: function () {
                              return _vm.controller.toggleFieldPin(
                                _vm.field.field_id
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "custom-field-label-pane__field-container-context" },
        [
          !_vm.controller.isLabelingField(_vm.field.field_id)
            ? _c(
                "ElTooltip",
                {
                  attrs: {
                    disabled: !_vm.controller.showSpaceScopeDisableTip(
                      _vm.field
                    ),
                    effect: "light",
                    "visible-arrow": false,
                    content: _vm.controller.generateSpaceScopeDisableTip(
                      _vm.field
                    ),
                    placement: "top",
                    "popper-class": "pt-ui-tooltip",
                  },
                },
                [
                  _c(_vm.renderComponent, {
                    tag: "component",
                    class: {
                      "disabled-edit": !_vm.controller.hasLabelFieldPermission(
                        _vm.field
                      ),
                    },
                    attrs: {
                      field: _vm.field,
                      value: _vm.controller.fieldValueMap[_vm.field.field_id],
                      locale: _vm.controller.getLocale(),
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.controller.startLabelingField(
                          _vm.field.field_id
                        )
                      },
                    },
                  }),
                ],
                1
              )
            : _c(_vm.editorComponent, {
                key: _vm.field.field_id,
                tag: "component",
                attrs: {
                  field: _vm.field,
                  value: _vm.controller.fieldValueMap[_vm.field.field_id],
                },
                on: {
                  endLabelingField: function () {
                    return _vm.controller.endLabelingField(_vm.field.field_id)
                  },
                  updateFieldValue: function ($event) {
                    return _vm.controller.onUpdateFieldValue({
                      fieldId: _vm.field.field_id,
                      value: $event,
                      field: _vm.field,
                    })
                  },
                },
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }